import { firebase } from "../helpers/firebase";

const firestore = firebase.firestore();
const collection = "usuarios";
const stateOneName = `${collection}_sel`;
const loadedName = `${collection}_load`;
const stateListName = `${collection}_list`;
const stateListColeName = `${collection}_list_colegio`;
const stateRapidCache = `${collection}_list_cache`;

const objectConst = {};
objectConst[stateListName] = [];
objectConst[stateOneName] = null;
objectConst[loadedName] = false;
objectConst[stateListColeName] = [];
objectConst[stateRapidCache] = [];

let state = objectConst;

let actions = {
  cleanAllUsuario({ commit }) {
    commit("setState", { key: stateOneName, value: null });
    commit("setState", { key: stateListName, value: [] });
    commit("setState", { key: stateListColeName, value: [] });
    commit("setState", { key: stateRapidCache, value: [] });
    commit("setState", { key: loadedName, value: false });
  },

  setOneUsuario({ commit, state }, id) {
    if (state.user) {
      const finded = state[stateListName].find(sn => sn.id === id);
      if (finded) commit("setState", { key: stateOneName, value: finded });
      return;
    }
    return Promise.reject(
      new Error("User is not logged for set action", collection)
    );
  },

  getUsuarioCloud({ state, commit }, id) {
    if (state.user) {
      const finded = state[stateRapidCache].find(elm => elm.id === id);
      if (finded) return Promise.resolve(finded);
      return firestore
        .collection(collection)
        .doc(id)
        .get()
        .then(doc => {
          if (doc.exists) {
            let currentVal = { id: doc.id, ...doc.data() };
            commit("setState", {
              key: stateRapidCache,
              value: [...state[stateRapidCache], currentVal]
            });
            return currentVal;
          } else return null;
        });
    }
    return Promise.reject(
      new Error("User is not logged for list action", collection)
    );
  },

  listUsuario({ commit, state }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .get()
        .then(querysnap => {
          commit("setState", { key: loadedName, value: false });
          const results = [];
          querysnap.forEach(doc => results.push({ id: doc.id, ...doc.data() }));
          commit("setState", { key: stateListName, value: results });
        })
        .catch(err => {
          commit("setState", { key: loadedName, value: false });
          throw err;
        });
    }
    return Promise.reject(
      new Error("User is not logged for list action", collection)
    );
  },

  // eslint-disable-next-line no-unused-vars
  async saveAuthUsuario({ commit }, pay) {
    commit("setState", { key: loadedName, value: true });
    let results;
    const initRq = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(pay)
    };
    const url =
      "https://us-central1-edutech-267418.cloudfunctions.net/apiFunction/api/v1/users";
    try {
      results = await fetch(url, initRq).then(res =>
        res.ok
          ? res.json()
          : (() => {
              throw new Error("Invalid request");
            })()
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    commit("setState", { key: loadedName, value: false });
    return results;
  },

  listUsuarioColegio({ commit, state }, query = []) {
    if (query && typeof query === "object") {
      query = Array.isArray(query) ? query : [query];
    } else {
      query = [];
    }
    if (state.user && state.colegios_sel) {
      commit("setState", { key: loadedName, value: true });
      let caller = firestore
        .collection(collection)
        .where(
          `permisos.${state.colegios_sel.id}.id`,
          "==",
          state.colegios_sel.id
        );
      for (const { property, op, value } of query) {
        caller = caller.where(property, op, value);
      }
      return caller
        .get()
        .then(querysnap => {
          commit("setState", { key: loadedName, value: false });
          const results = [];
          querysnap.forEach(doc => results.push({ id: doc.id, ...doc.data() }));
          commit("setState", { key: stateListColeName, value: results });
        })
        .catch(err => {
          commit("setState", { key: loadedName, value: false });
          throw err;
        });
    }
    return Promise.reject(
      new Error("User is not logged for list action", collection)
    );
  },

  storeUsuario({ commit, state }, { data }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .add(data)
        .then(docRef => {
          commit("setState", { key: loadedName, value: false });
          commit("setState", {
            key: stateListName,
            value: [...state[stateListName], { id: docRef.id, ...data }]
          });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for store action", collection)
    );
  },

  updateUsuario({ commit, state }, { id, data }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .doc(id)
        .update(data)
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          for (let i = 0; i < stateCopy.length; i++) {
            if (stateCopy[i].id === id)
              stateCopy[i] = Object.assign({}, stateCopy[i], data);
          }
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for update action", collection)
    );
  },

  removeUsuario({ commit, state }, { id }) {
    if (state.user) {
      commit("setState", { key: loadedName, value: true });
      return firestore
        .collection(collection)
        .doc(id)
        .delete()
        .then(() => {
          commit("setState", { key: loadedName, value: false });
          const stateCopy = state[stateListName];
          const index = stateCopy.findIndex(st => st.id === id);
          if (index > -1) stateCopy.splice(index, 1);
          commit("setState", { key: stateListName, value: stateCopy });
        })
        .catch(error => {
          commit("setState", { key: loadedName, value: false });
          throw error;
        });
    }
    return Promise.reject(
      new Error("User is not logged for remove action", collection)
    );
  }
};

export default {
  state,
  actions,
  names: {
    collection,
    sel: stateOneName,
    list: stateListName,
    load: loadedName
  }
};
